import { Stack } from "@mui/material"
import { colors } from "../../../services/config/colors"
import Text from "../../global/common/Text"
import ticketsIcon from "../../../assets/icons/tickets.svg"
import rocketIcon from "../../../assets/icons/rocket.svg"
import { Trans } from "react-i18next"
import FadeFromTop from "../../animations/FadeFromTop"
import { useContext } from "react"
import { MainContext } from "../../../controllers/main"

const MissionsCardDesktop = () => {
  const { isChallengeOver } = useContext(MainContext)

  return (
    <FadeFromTop delay={0.075} y={-40}>
      <Stack
        alignItems="center"
        style={{
          width: "100%",
          maxWidth: 330,
          height: 427,
          backgroundColor: colors.background,
          borderRadius: 20,
          border: "2px solid " + colors.primary,
          paddingTop: 30,
          paddingInline: 30,
          position: "relative",
        }}
      >
        <img
          src={isChallengeOver ? rocketIcon : ticketsIcon}
          style={{ height: 50 }}
          alt=""
        />
        <Text
          fontSize={20}
          fontWeight={400}
          lineHeight="24px"
          textAlign="center"
          style={{ marginTop: 32 }}
        >
          <Trans
            i18nKey={
              isChallengeOver
                ? "missions_card_text_challenge_over"
                : "missions_card_text"
            }
          />
        </Text>
      </Stack>
    </FadeFromTop>
  )
}

export default MissionsCardDesktop
